var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreakfast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.41 8.095c-.134-1.037-1.083-1.775-2.129-1.775H9.667c-1.673 0-2.622.738-2.756 1.775-.154 1.187.603 2.195 1.73 2.303v5.55c0 .752.608 1.361 1.361 1.361h6.317c.752 0 1.362-.61 1.362-1.362v-5.549c1.126-.108 1.883-1.116 1.729-2.303",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.41 8.095c-.134-1.037-1.083-1.775-2.129-1.775H9.667c-1.673 0-2.622.738-2.756 1.775-.154 1.187.603 2.195 1.73 2.303v5.55c0 .752.608 1.361 1.361 1.361h6.317c.752 0 1.362-.61 1.362-1.362v-5.549c1.126-.108 1.883-1.116 1.729-2.303z",
    stroke: "#666",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.59 8.095c-.135-1.037-1.084-1.775-2.13-1.775H6.846c-1.672 0-2.621.738-2.756 1.775-.154 1.187.603 2.195 1.73 2.303v5.55c0 .752.609 1.361 1.361 1.361h6.317c.753 0 1.362-.61 1.362-1.362v-5.549c1.126-.108 1.883-1.116 1.73-2.303",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.59 8.095c-.135-1.037-1.084-1.775-2.13-1.775H6.846c-1.672 0-2.621.738-2.756 1.775-.154 1.187.603 2.195 1.73 2.303v5.55c0 .752.609 1.361 1.361 1.361h6.317c.753 0 1.362-.61 1.362-1.362v-5.549c1.126-.108 1.883-1.116 1.73-2.303z",
    stroke: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.487 14.355a.594.594 0 11-1.187.001.594.594 0 011.187-.001M11.317 9.41a.594.594 0 11-1.188.001.594.594 0 011.188 0M12.565 14.739a.384.384 0 11-.769 0 .384.384 0 01.769 0M14.26 7.907a.384.384 0 11-.769 0 .384.384 0 01.769 0M8.87 11.727a.384.384 0 11-.767 0 .384.384 0 01.768 0M11.941 12.583a.743.743 0 11-1.248-.806.743.743 0 011.248.806M7.634 8.29a.743.743 0 11-1.487 0 .743.743 0 011.487 0",
    fill: "#666"
  }))));
}
export default SvgBreakfast;